import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Simulation } from '../../types';
import { api } from '../api';

interface SimulationsState {
  selectedSimulationId: string | null;
  filterOptions: {
    type: string | null;
    status: string | null;
  };
  sortBy: 'created_at' | 'name' | 'status';
  sortDirection: 'asc' | 'desc';
}

const initialState: SimulationsState = {
  selectedSimulationId: null,
  filterOptions: {
    type: null,
    status: null,
  },
  sortBy: 'created_at',
  sortDirection: 'desc',
};

const simulationsSlice = createSlice({
  name: 'simulations',
  initialState,
  reducers: {
    selectSimulation: (state, action: PayloadAction<string | null>) => {
      state.selectedSimulationId = action.payload;
    },
    setTypeFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.type = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string | null>) => {
      state.filterOptions.status = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'created_at' | 'name' | 'status'>) => {
      state.sortBy = action.payload;
    },
    setSortDirection: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortDirection = action.payload;
    },
    clearFilters: (state) => {
      state.filterOptions = {
        type: null,
        status: null,
      };
    },
  },
  extraReducers: (builder) => {
    // Reset selection when simulations are fetched
    builder.addMatcher(
      api.endpoints.getSimulations.matchFulfilled,
      (state) => {
        if (!state.selectedSimulationId) return;
      }
    );
  },
});

export const {
  selectSimulation,
  setTypeFilter,
  setStatusFilter,
  setSortBy,
  setSortDirection,
  clearFilters,
} = simulationsSlice.actions;

export default simulationsSlice.reducer;
